<template>
  <div id="portfolio" class="site-container">
    <navigation></navigation>

    <div class="images-wrapper">
      <router-link :to="{ name: 'album', params: {slug: c.slug} }" v-for="(c, idx) in categories" :key="idx">
        <div class="image-wrapper">
          <h4>{{ c.name }}</h4>
          <div class="img" v-bind:style="{background: 'url(' + c.src + ')'}"></div>
        </div>
      </router-link>
    </div>

    <footer>
      <div class="copyright">
        All images &copy; 2018-<span v-text="new Date().getFullYear()"></span> Jovana Ivic
      </div>
    </footer>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Navigation from "../components/Navigation";

  export default {
    name: 'my-work',
    components: {Navigation},
    watch: {
      '$route'() {
        window.scrollTo(0, 0);
      }
    },
    data() {
      return {
        categories: [
          {
            'slug': 'motorcycle',
            'name': 'Motorcycle',
            'src': '/img/Motorcycle/DSC09396_800.jpg'
          },
          {
            'slug': 'diner',
            'name': 'Diner',
            'src': '/img/Diner/DSC02645_800.jpg'
          },
          {
            'slug': 'western-darlin',
            'name': 'Western Darlin',
            'src': '/img/WesternDarlin/DSC01446_800.jpg'
          },
          {
            'slug': 'birthday',
            'name': 'Birthday',
            'src': '/img/Birthday/DSC01853_800.jpg'
          },
          {
            'slug': 'bookstore',
            'name': 'Bookstore',
            'src': '/img/Bookstore/DSC08978_800.jpg'
          },
          {
            'slug': 'first-snow',
            'name': 'First Snow',
            'src': '/img/FirstSnow/DSC06530_800.jpg'
          },
          {
            'slug': 'yellow',
            'name': 'Yellow',
            'src': '/img/Yellow/DSC02658_800.jpg'
          },
          {
            'slug': 'green',
            'name': 'Green',
            'src': '/img/Green/DSC00992_800.jpg'
          },
          {
            'slug': 'street-lights',
            'name': 'Street Lights',
            'src': '/img/StreetLights/DSC07400_800.jpg'
          },
          {
            'slug': 'family',
            'name': 'Family',
            'src': '/img/Family/DSC07881_800.jpg'
          },
          {
            'slug': 'couple',
            'name': 'Couple',
            'src': '/img/Couple/DSC03945_800.jpg'
          },
          {
            'slug': 'headshots',
            'name': 'Headshots',
            'src': '/img/Headshots/DSC07582_800.jpg'
          },
          {
            'slug': 'christmas',
            'name': 'Christmas',
            'src': '/img/Christmas/DSC09466_800.jpg'
          },
          {
            'slug': 'congress-ave',
            'name': 'Congress Ave',
            'src': '/img/CongressAve/DSC03879_800.jpg'
          },
          {
            'slug': 'poet',
            'name': 'Poet',
            'src': '/img/Poet/DSC04408_800.jpg'
          }
        ]
      }
    },
    methods: {},
    mounted() {
    },
    destroyed() {
    }
  }
</script>
